module.exports = __webpack_public_path__ + "img/Payment.ab898379.png";